import React, { Fragment, useEffect, useState, useContext } from 'react'
import Grid from '@material-ui/core/Grid'
import useStyles from "./styles";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { Document, Page, pdfjs } from "react-pdf";
import summaryForm from "../../../shared/PaSummaryConfig";
import inquiryForm from "../../../shared/PaInquiryConfig";
import FilesList from "../../FileList";
import CompoundViewTable from "../CreatePa/InputTypes/CompoundViewTable";
import PaFormFields from "../../../shared/PaFormFields";
import AppContext from '../../../contexts/App/App.context'
import { fetchPaSummaryPdf } from "../../../shared/api-service";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function SummaryView({record, operation, exceptions = []}) {
    const [fileUrl, setFileUrl] = useState(null);
    const [numPages, setNumPages] = useState(null);
    const npi = record.npiNumber;
    const authNumber = record.authNumber;

    const classes = useStyles();
    const appContext = useContext(AppContext)

    // Fetch PDF
    useEffect(() => {
        if (!authNumber) return
        if (!record.attachments?.some(f => f.name?.includes("PA_SUMMARY"))) return

        const fetchPdf = async () => {
            try {
                const res = await fetchPaSummaryPdf(npi, authNumber);
                const arrayBuffer = await res.arrayBuffer();
                const blob = new Blob([arrayBuffer], { type: "application/pdf" });

                setFileUrl(URL.createObjectURL(blob));
            } catch (err) {
                console.log("Error fetching PDF")
            }
        }

        fetchPdf();
    }, [npi, authNumber, record]);

    const getOption = (field, value) => {
        let newValue = '';
        if (PaFormFields[field] && PaFormFields[field].options) {
            const option = PaFormFields[field].options.find(item => item.value === value)
            if (option && option.label) {
                newValue = option.label;
            }
        }
        return newValue;
    }
    const getYesNo = (value) => {
        return (value === 'yes' || value === true) ? 'Yes' : 'No';
    }

    const getAllergy = (value) => {
        return (value === 'yes') ? 'Yes' : 'No Known Allergies'
    }

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    }

    const renderPdf = () => {
        if (operation === 'create') return
        if (!fileUrl) return <p>Loading PDF...</p>
        const fileName = record.attachments?.find(f => f.name?.includes("PA_SUMMARY"));

        return (
            <div className={classes.formGroup}>
                <Typography className={classes.standOutText}><span className={classes.blueHeader}>Initial PA Request:</span> {fileName.name}</Typography>
                <Box className={classes.formBox}>
                    <Document file={fileUrl} onLoadSuccess={onDocumentLoadSuccess}>
                            <Page
                                className={classes.page} 
                                pageNumber={1}
                                scale={2}
                                renderAnnotationLayer={false}
                                renderTextLayer={false}
                            />
                    </Document>
                </Box>
            </div>
        )
    }

    const renderForm = (form) => {
        if (!form) return null;

        return form.map((item, index) => {
            return(
                <div key={index} className={classes.formGroup}>
                    <Typography className={classes.standOutText}>{item.title.text}</Typography>
                    <Box className={classes.formBox}>
                        <Grid item container>
                            {item.items && item.items.map( (field, childIndex) => {
                                const {label, toggleFn, value, renderFn} = field;
                                let valueVar = value.property.split('.').filter(i=>i)
                                valueVar = valueVar.length === 2 ? record[valueVar[0]][valueVar[1]] : record[valueVar[0]]
                                valueVar = valueVar && valueVar.push ? valueVar.join(',') : valueVar;
                                //const isBoolean = typeof valueVar === 'boolean';
                                const visible = toggleFn ? toggleFn(record, operation) : true;

                                    valueVar = renderFn ? renderFn(record, operation, appContext) : valueVar

                                    if (!visible) return <Fragment key={childIndex}/>;

                                    return (
                                        <Fragment key={childIndex}>
                                            <Grid style={{...item.labelStyle, ...label.style}} item
                                                    xs={label.size.xs} md={label.size.md}
                                                    className={classes.formDataCell}>
                                            <span className={classes.formLabel}>
                                                {label.text}
                                            </span>
                                            </Grid>
                                            <Grid style={{...item.inputStyle, ...value.style}} item
                                                    xs={value.size.xs} md={value.size.md}
                                                    className={classes.formDataCell}>
                                                {["", null, undefined].includes(valueVar) && !value.type && 'Not Provided'}
                                                {!value.type && valueVar}
                                                {value.type && value.type === 'option' && getOption(value.property, valueVar)}
                                                {value.type && value.type === 'checkbox' &&
                                                <input type="checkbox" checked={valueVar} disabled/>}
                                                {value.type && value.type === 'yesNo' && getYesNo(valueVar)}
                                                {value.type && value.type === 'allergic' && getAllergy(valueVar)}
                                                {value.type && value.type === 'noValue' && ''}
                                                {value.type && value.type === 'compound' &&
                                                <CompoundViewTable row={childIndex}
                                                                    compounds={record.compounds}
                                                                    hideHeader={true}/>}
                                            </Grid>
                                        </Fragment>
                                    )
                                })}
                        </Grid>
                    </Box>
                </div>
            )
        })
    }
    
    return (
        <Grid id='MEDCAL_RX_SUMMARY' container spacing={2} className={classes.root}>
            <Grid container alignItems='center' spacing={0} item xs={12}>
                <Grid item xs={12}>
                    {operation === 'create' ? renderForm(summaryForm) : renderForm(inquiryForm)}

                    <div className={classes.formGroup}>
                        <FilesList files={record.attachments}/>
                    </div>
                    {operation !== 'create' && record.attachments?.some(f => f.name?.includes("PA_SUMMARY")) ? renderPdf() : ""}
                </Grid>
            </Grid>
        </Grid>
    );
}
